<template>

	<div class="board_category swiper-container">
		<ul class="swiper-wrapper">
			<li class="swiper-slide" :class="{ 'active': (selectedCode === '') }"><button type="button" @click="selectCode('')">전체</button></li>

			<li class="swiper-slide" :class="{ 'active': (selectedCode === item.code) }" v-for="(item, index) in codeList"><button type="button" @click="selectCode(item.code)">{{ item.codeName }}</button></li>
		</ul>
	</div>

</template>

<script>
import Swiper from '../../../../public/ssflex_cs1/assets/js/swiper.min'

export default {
	name: "codeSelector",
	props: {
		field: String,  // 파라미터에서 가져올 코드 필드 지정
		code: String
	},
	data () {

		return {

			selectedCode: this.webUtils.getParameter( this.field ),
			codeVO: {},
			codeList: [],
		}
	},
	created() {

	},
	mounted() {

		if ( this.code !== undefined && this.code !== '' ) {
			this.init( this.code );
		}
	},
	methods: {

		async init (_code) {

			if ( this.code !== undefined && this.code !== '' ) {

				const self = this
				this.codeVO = await this.getCodeOne( _code );
				if ( this.codeVO.children.length > 0 ) {
					this.codeList = this.codeVO.children

					this.$nextTick(() => {

						new Swiper(".board_category", {
							slidesPerView: "auto",
							spaceBetween: 24,
							freeMode: true,
							breakpoints: {
								767: {
									spaceBetween: 16,
								},
							},
						});
					})
				}
			}
		},


		selectCode ( _code ) {
			this.$emit("selectCode", _code)
		}

	},
	watch: {

		code: function ( val ) {
			this.init( val )
		},

	}
}
</script>

<style scoped>

</style>